import { useEffect, useContext, useState } from 'react';
import Layout from '../components/Layout/Layout'
import { AuthContext } from "../hoc/AuthContext"; // Adjust path as needed
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_OLD_WMS_API_BASE_URL;
const bearer_token = process.env.REACT_APP_AUTH_TOKEN || "";


export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const { setIsAuthenticated,setAuthUserData,authUserData } = useContext(AuthContext);

  const USER_SESSION_KEY = "wms-user-token";

  // ✅ Email format checker
  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ Frontend validation
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!isValidEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }
    if (!password) {
      setError("Password is required");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}v2/user/login`, {
        email,
        password,
      }, {
        headers: {
          'Authorization': `Bearer ${bearer_token}`
        }
      });

      const { userData } = response?.data?.data || {};

      if (!userData?.auth_token) {
        if(response?.data?.message)
        throw new Error(response?.data?.message);
        else
        throw new Error("No token returned from API");
      }

      // Save token (stringified user object encoded if needed)
      const user = JSON.stringify(userData || { email });
      const encoded = btoa(user); // base64 encode for your context
      localStorage.setItem(USER_SESSION_KEY, encoded);
      const token=user.auth_token
      // Update context
      setIsAuthenticated(true);
      setAuthUserData({...response.data.data,auth_token: token})

      // Redirect to home/dashboard
      navigate("/");
    } catch (err) {
      console.log(err)
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError(err.message || "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };
  /*const { isAuthenticated, authLoading } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    //console.log(isAuthenticated)
    if(!authLoading && isAuthenticated) {
       navigate('/')
    }
     
  },[isAuthenticated])

  // ✅ Email format checker
  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // ✅ Frontend validation
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!isValidEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }
    if (!password) {
      setError("Password is required");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post("https://stg-wms-api.jnm.digital/api/login", {
        email,
        password,
      });

      setSuccess("Login successful ✅");
      console.log("Response Data:", response.data);

      // Example: Save token
      if (response.data?.data?.userData) {
        localStorage.setItem("token", response.data.data.userData);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || "Invalid credentials");
      } else {
        setError("Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };*/

  
  //console.log(isAuthenticated)
  return (
    <>
    <Layout noheader="noheader">
      
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        {/* <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            alt="Your Company"
            src="https://www.jagranimages.com/images/jagran-icon.svg"
            className="mx-auto h-16 w-auto"
          />
          <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div> */}

        <div className="mt-10 sm:mx-auto sm:w-full max-w-3xl">
          <div className="bg-white px-6 py-12 shadow rounded-2xl sm:px-12">
            {/* <h2 className="text-center mb-4 text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Sign in to your account
            </h2> */}
            {/* {!isAuthenticated ? <><a className="flex w-full justify-center rounded-md bg-red-600 px-3 py-3 text-sm font-semibold leading-6 text-white uppercase shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600" href='https://wms.jnm.digital/login2'>Login is working though Old WMS only! Click to login</a></> : */}
            <div className='grid grid-cols-1 lg:grid-cols-2'>
              <div className='col-span-1 flex items-center'>
                <div>
                  <figure><svg className="h-10 w-24"><use href="#wms"></use></svg></figure>
                  <h3 className='uppercase font-bold text-[15px]'>Website Management System</h3>
                  <p className='text-[10px] tracking-[0.06rem] uppercase text-gray-400'>Single Platform, Endless Possibilities</p>
                </div>
              </div>
              <form onSubmit={handleSubmit} className="space-y-6 col-span-1">
      <div>
        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
          Email
        </label>
        <div className="mt-2">
          <input
            id="email"
            name="email"
            type="text"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={(e) => setEmail(e.target.value.trim())}
            className="block w-full rounded-md border-0 py-2.5 px-2.5 outline-none text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 
            placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
          Password
        </label>
        <div className="mt-2">
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="block w-full rounded-md border-0 py-2.5 px-2.5 outline-none text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 
            placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      <div>
        <button
          type="submit"
          disabled={loading}
          className="flex w-full justify-center rounded-md bg-red-600 px-3 py-3 text-sm font-semibold leading-6 
          text-white uppercase shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 
          focus-visible:outline-offset-2 focus-visible:outline-red-600 disabled:opacity-50"
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </div>

      {error && <p className="text-red-600 text-sm">{error}</p>}
      {success && <p className="text-green-600 text-sm">{success}</p>}
    </form>
            </div>
            {/* } */}
          </div>
        </div>
      </div>
    </Layout>
    </>
  )
}
